import { Card, CardContent } from "@ncoder/ui";
import { ChevronRight } from "lucide-react";

interface QuickActionCardProps {
  id: string;
  title: string;
  description: string;
  icon: React.ElementType;
  color: string;
  onClick: () => void;
}

export const QuickActionCard: React.FC<QuickActionCardProps> = ({
  title,
  description,
  icon: Icon,
  color,
  onClick,
}) => (
  <Card
    onClick={onClick}
    className="cursor-pointer hover:shadow-lg transition-all"
  >
    <CardContent className="p-4">
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 bg-gradient-to-r ${color} rounded-lg flex items-center justify-center`}
        >
          <Icon className="h-5 w-5 text-white" />
        </div>
        <div>
          <h3 className="font-medium">{title}</h3>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        <ChevronRight className="h-4 w-4 text-muted-foreground ml-auto" />
      </div>
    </CardContent>
  </Card>
);
